const keys = {
  me: ['me'],
  companies: ['me', 'companies']
};

export default keys;
